import { render } from "./FaultSetting.vue?vue&type=template&id=56f26346"
import script from "./FaultSetting.vue?vue&type=script&lang=js"
export * from "./FaultSetting.vue?vue&type=script&lang=js"

import "./FaultSetting.vue?vue&type=style&index=0&id=56f26346&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__